import { getChanceToDealHits } from '../../utils/getHitsProbability.js';
import doesEnemyPoseAThreat from './doesEnemyPoseAThreat.js';
function collectAgentCandidates(agentSide, allUnits, mapHexes, hexProperties, rules, chanceLimit = 0.5) {
    const agentCandidates = [];
    const agentUnits = allUnits.filter((unit) => unit.side === agentSide);
    const enemyUnits = allUnits.filter((unit) => unit.side !== agentSide);
    agentUnits.forEach((agentUnit) => {
        enemyUnits.forEach((enemyUnit) => {
            const isEnemyAThreat = doesEnemyPoseAThreat({
                enemyUnit,
                unitInPossibleDanger: agentUnit,
                hexProperties,
                rules,
                allUnits,
                mapHexes,
            });
            if (!isEnemyAThreat) {
                return;
            }
            // @TODO: what about positions?
            const chanceForEnoughHits = getChanceToDealHits(enemyUnit, agentUnit, agentUnit.health, rules);
            if (chanceForEnoughHits >= chanceLimit) {
                agentCandidates.push({ agentUnit, enemyUnit, chanceForEnoughHits });
            }
        });
    });
    agentCandidates.sort((a, b) => {
        return b.chanceForEnoughHits - a.chanceForEnoughHits;
    });
    return agentCandidates;
}
export default collectAgentCandidates;
